<!-- eslint-disable -->
<template>
    <div class="minimal-auth-wrapper">
        <div class="auth-container">
            <!-- Logo Section -->
            <div class="logo-section" v-if="app.logo">
                <b-img :src="app.logo" alt="Logo" class="brand-logo" />
            </div>

            <!-- Main Card -->
            <div class="login-card">
                <!-- Header -->
                <div class="login-header text-center">
                    <h1 class="login-title">Enlace enviado</h1>
                </div>

                <!-- Success Alert -->
                <div class="success-alert">
                    <div class="alert-icon">
                        <feather-icon icon="MailIcon" size="32" />
                    </div>
                    <div class="alert-content">
                        <strong>Revisa tu email</strong>
                        <p class="text-muted mb-0">Enviado a:</p>
                        <strong class="email-text">{{ userEmail }}</strong>
                        <p class="expiry-text">
                            Haz clic en el enlace para acceder (expira en 15
                            minutos)
                        </p>
                    </div>
                </div>

                <!-- Action Buttons -->
                <b-button
                    variant="primary"
                    block
                    class="submit-btn mb-3"
                    :disabled="isResending || countdown > 0"
                    @click="resendMagicLink"
                >
                    <feather-icon icon="RefreshCwIcon" class="mr-1" />
                    {{ resendButtonText }}
                </b-button>

                <b-button
                    variant="outline-secondary"
                    block
                    class="back-btn"
                    @click="goToLogin"
                >
                    <feather-icon icon="ArrowLeftIcon" class="mr-1" />
                    Volver al login
                </b-button>

                <!-- Help Text -->
                <div class="info-text">
                    <feather-icon icon="HelpCircleIcon" size="16" />
                    <span>¿No lo ves? Revisa spam o reenvía el enlace</span>
                </div>
            </div>

            <!-- Payment Methods -->
            <div class="payment-methods">
                <p class="payment-label">Métodos de pago</p>
                <div class="payment-images">
                    <b-img :src="brands.visa" alt="Visa" class="brand-img" />
                    <b-img
                        :src="brands.mastercard"
                        alt="Mastercard"
                        class="brand-img"
                    />
                    <b-img
                        :src="brands.visaSecure"
                        alt="Visa Secure"
                        class="brand-img"
                    />
                    <b-img
                        :src="brands.mcIdCheck"
                        alt="Mastercard ID Check"
                        class="brand-img"
                    />
                    <b-img
                        :src="imgPayPal"
                        alt="PayPal"
                        class="payment-img-paypal"
                    />
                </div>
            </div>

            <!-- Enlaces legales -->
            <div class="legal-links">
                <b-link :to="{ name: 'legal-services' }">Servicios</b-link>
                <b-link :to="{ name: 'legal-terms' }">Términos</b-link>
                <b-link :to="{ name: 'legal-privacy' }">Privacidad</b-link>
                <b-link :to="{ name: 'legal-security' }">Seguridad</b-link>
                <b-link :to="{ name: 'legal-refunds' }">Devoluciones</b-link>
                <b-link :to="{ name: 'legal-delivery' }">Entrega</b-link>
                <b-link :to="{ name: 'legal-contact' }">Contacto</b-link>
            </div>

            <!-- Datos del comercio -->
            <div class="business-info">
                <div>
                    {{ business.name }} · {{ business.address }} ·
                    {{ business.country }}
                </div>
                <div>
                    <a :href="`tel:${business.phone}`">{{ business.phone }}</a>
                    ·
                    <a :href="`mailto:${business.email}`">{{
                        business.email
                    }}</a>
                </div>
            </div>

            <!-- Footer -->
            <div class="page-footer">
                <feather-icon icon="LockIcon" size="14" />
                <span>Conexión segura</span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
    BAlert,
    BButton,
    BCard,
    BCardBody,
    BCardText,
    BCardTitle,
    BCol,
    BImg,
    BLink,
    BRow,
} from "bootstrap-vue";
import business from "@/business";

export default {
    components: {
        BRow,
        BCol,
        BButton,
        BCard,
        BCardBody,
        BCardTitle,
        BLink,
        BCardText,
        BAlert,
        ToastificationContent,
        BImg,
    },
    data() {
        return {
            userEmail: "",
            isResending: false,
            countdown: 0,
            countdownInterval: null,
            app: {
                banner: "",
                nombre: "",
                logo: "",
            },
            business,
            imgPayPal: require("@/assets/images/logo/paypal.png"),
            brands: {
                visa: require("@/assets/images/brands/visa.jpg"),
                mastercard: require("@/assets/images/brands/mastercard.jpg"),
                visaSecure: require("@/assets/images/brands/visa-secure.png"),
                mcIdCheck: require("@/assets/images/brands/mastercard-idcheck.png"),
            },
        };
    },
    computed: {
        resendButtonText() {
            if (this.isResending) {
                return "Reenviando...";
            }
            if (this.countdown > 0) {
                return `Reenviar en ${this.countdown}s`;
            }

            return "Reenviar enlace";
        },
    },
    created() {
        this.$http
            .get("/get-env")
            .then((response) => {
                this.app.banner = response.data.data.app_banner;
                this.app.name = response.data.data.app_name;
                this.app.logo = response.data.data.app_logo;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    mounted() {
        this.userEmail = this.$route.params.email || "";
        this.startResendCountdown();
    },
    beforeDestroy() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    },
    methods: {
        startResendCountdown() {
            this.countdown = 60; // 60 segundos de espera para reenviar
            this.countdownInterval = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.countdownInterval);
                }
            }, 1000);
        },

        async resendMagicLink() {
            if (!this.userEmail) {
                this.$swal({
                    title: "Error",
                    text: "Email no encontrado. Por favor vuelva al login.",
                    icon: "error",
                });

                return;
            }

            this.isResending = true;

            try {
                await useJwt.sendMagicLink(this.userEmail);

                this.showToast(
                    "Enlace reenviado correctamente",
                    "success",
                    "MailIcon"
                );

                // Reiniciar contador
                this.startResendCountdown();
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text:
                        error.response?.data?.message ||
                        "Error reenviando el enlace",
                    icon: "error",
                });
            } finally {
                this.isResending = false;
            }
        },

        goToLogin() {
            this.$router.push({ name: "auth-login" });
        },

        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant,
                    icon,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";
@import "@/assets/scss/auth-minimal";
</style>
